import { datadogRum } from "@datadog/browser-rum"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { createRoot } from "react-dom/client"
import TagManager from "react-gtm-module"
import { HelmetProvider } from "react-helmet-async"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "unfetch/polyfill"

import { ReactQueryProvider } from "@front-shared/providers/reactQuery.provider"

import { RouterContainer } from "./containers/router.container"
import { appStore } from "./store"

import "@front-shared/assets/styles/antd.less"
import "@front-shared/assets/styles/overrides.less"

import "./assets/styles/index.less"
import "./assets/styles/tailwind.less"

// INIT STRIPE
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_TOKEN as string)

// INIT GOOGLE TAG MANAGER
if (import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID) {
    TagManager.initialize({
        gtmId: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID,
        dataLayer: {},
    })
}

// INIT DATADOG
if (
    import.meta.env.VITE_DD_APP_ID &&
    import.meta.env.VITE_DD_CLIENT_TOKEN &&
    import.meta.env.VITE_DD_SERVICE
) {
    datadogRum.init({
        applicationId: import.meta.env.VITE_DD_APP_ID,
        clientToken: import.meta.env.VITE_DD_CLIENT_TOKEN,
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: "datadoghq.com",
        service: import.meta.env.VITE_DD_SERVICE,
        env: import.meta.env.VITE_ENV,
        version: import.meta.env.VITE_RELEASE_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask",
    })
}

const root = document.getElementById("root")

if (root) {
    createRoot(root).render(
        // TODO: Enable StrictMode again when all issues are fixed - currently we need to refactor quite a few things
        // like Antd usage, etc.
        // because our elements are old, we get a lot of issues with strict mode remounting components twice, etc.
        // <StrictMode>
        <Provider store={appStore}>
            <BrowserRouter>
                <Elements stripe={stripePromise}>
                    <ReactQueryProvider>
                        <HelmetProvider>
                            <RouterContainer />
                        </HelmetProvider>
                    </ReactQueryProvider>
                </Elements>
            </BrowserRouter>

            <ToastContainer
                autoClose={4 * 1000}
                position="top-right"
                newestOnTop
                pauseOnHover
                closeOnClick
                hideProgressBar
            />
        </Provider>,
        // </StrictMode>,
    )
}
